export default __webpack_public_path__ + "static/media/help.e465b587.svg";